import {Routes} from '@angular/router';
import {conciergeRoutes} from "./concierge-app/concierge-routing";
import {H5PageComponent} from "./h5-page/h5-page.component";
import {UserResolverActivate} from "./shared/service/auth/guards/auth-guard.service";
import {LanguageResolver} from "./shared/service/lang/lang-resolver.service";

export const appRoutes: Routes = [
  {
    path: 'app',
    canActivate: [UserResolverActivate],
    resolve: {langResolved: LanguageResolver},
    children: conciergeRoutes,
  },
  // {
  //   path: 'reservation/:resId/h5',
  //   resolve: {langResolved: LanguageResolver},
  //   component: H5PageComponent
  // },
  {
    path: '**', redirectTo: 'app', pathMatch: 'full'
  },
];
